import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { dashboardPaths, executiveSummaryPaths } from './paths';

const { Dashboard } = lazyImport(() => import('../views/dashboard'), 'Dashboard');
const { ExecutiveSummary } = lazyImport(() => import('../views/executiveSummary'), 'ExecutiveSummary');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const dashboardRoutes: RouteObject[] = [
  {
    path: dashboardPaths.absolute,
    element: <Layout />,
    children: [
      {
        path: dashboardPaths.fullDashboard.relative,
        element: <Dashboard />,
      },
    ],
  },
  {
    path: executiveSummaryPaths.absolute,
    element: <Layout />,
    children: [
      {
        path: '',
        element: <ExecutiveSummary />,
      },
    ],
  },
];
